import { render } from "./EditorPage.vue?vue&type=template&id=03e5edfc&scoped=true"
import script from "./EditorPage.vue?vue&type=script&lang=js"
export * from "./EditorPage.vue?vue&type=script&lang=js"

import "./EditorPage.vue?vue&type=style&index=0&id=03e5edfc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03e5edfc"]])

export default __exports__